import React from 'react';
import { Phone, Mail } from 'lucide-react';

const AdminClientInfo = ({ client }) => {
  if (!client) return null;

  return (
    <div className="bg-surface border rounded-lg p-2 sm:p-3">
      <h3 className="text-sm sm:text-base font-bold text-black mb-2 sm:mb-3">Client Information</h3>
      <div className="space-y-1.5 sm:space-y-2">
        <div>
          <p className="text-xs text-gray-600 font-medium mb-0.5">Name</p>
          <p className="text-xs sm:text-sm font-medium text-black break-words">{client.name || 'Unknown Client'}</p>
        </div>
        {client.email && (
          <div className="flex items-start gap-1.5">
            <Mail className="w-3.5 h-3.5 text-black mt-0.5 flex-shrink-0" />
            <p className="text-xs sm:text-sm text-black break-all">{client.email}</p>
          </div>
        )}
        {client.phone && (
          <div className="flex items-center gap-1.5">
            <Phone className="w-3.5 h-3.5 text-black flex-shrink-0" />
            <p className="text-xs sm:text-sm text-black break-words">{client.phone}</p>
          </div>
        )}
      </div>

      {/* Action Buttons */}
      {client.phone && (
        <div className="mt-3 sm:mt-4 pt-3 border-t-2 border-gray-300">
          <a
            href={`tel:${client.phone}`}
            className="flex items-center justify-center gap-1.5 sm:gap-2 w-full px-2 sm:px-3 py-1.5 sm:py-2 bg-black text-white rounded-lg hover:bg-gray-900 transition-colors text-xs sm:text-sm font-medium"
          >
            <Phone className="w-3.5 h-3.5 sm:w-4 sm:h-4 flex-shrink-0" />
            <span className="truncate">Call Client</span>
          </a>
        </div>
      )}
    </div>
  );
};

export default AdminClientInfo;

